'use strict'

module.exports = require('./lib/key-encoder')


//////////////////
// WEBPACK FOOTER
// ./~/key-encoder/index.js
// module id = 638
// module chunks = 0